/**
 * Chuỗi của tab Cấu hình lỗi (`/rpa/alert-config?tab=errors`) — namespace `rpa.errorCodes` của web-portal native, đổi
 * sang kiểu dấu thanh mới. Tạm tách tệp, sẽ gộp vào `vi.ts`.
 */
export const viRpaLoi = {
  rpaLoi: {
    gioiThieu:
      'Bảng lỗi bắt đầu trống. Khi flow OpenRPA bắt được một exception, Robot báo lên đây; bạn tạo loại lỗi từ exception đó rồi đặt cách xử lý. Exception chưa đặt cách xử lý được thử một lần, bỏ qua và báo, rồi chạy tiếp.',
    mucDo: {
      critical: 'Nghiêm trọng',
      high: 'Cao',
      medium: 'Trung bình',
      low: 'Thấp',
    },
    cho: {
      tieuDe: 'Exception chờ đặt cách xử lý',
      moTa: 'Robot đã báo các exception này nhưng chưa thuộc loại lỗi nào.',
      soDangCho: '{{so}} đang chờ',
      locTrangThai: 'Lọc theo trạng thái',
      PENDING: 'Đang chờ',
      IGNORED: 'Đã bỏ qua',
      rong: 'Chưa có exception nào đang chờ',
      rongMoTa: 'Chạy flow có lỗi, exception Robot báo lên sẽ hiện ở đây để bạn đặt cách xử lý.',
      rongBoQua: 'Không có exception nào đã bỏ qua',
      soLan: 'Gặp {{so}} lần',
      lanCuoi: 'Lần cuối {{luc}}',
      buoc: 'Bước: {{buoc}}',
      luong: 'Workflow: {{luong}}',
      taoCode: 'Tạo loại lỗi mới',
      gan: 'Gán vào loại lỗi có sẵn',
      chuaCoCode: 'Chưa có loại lỗi nào để gán',
      boQua: 'Bỏ qua',
      dangBoQua: 'Đang bỏ qua...',
      daBoQua: 'Đã bỏ qua {{exception}}.',
      danhSach: 'Danh sách exception chờ',
    },
    code: {
      tieuDe: 'Loại lỗi',
      moTa: 'Mỗi dòng là một loại lỗi và cách Robot xử lý nó.',
      them: 'Thêm loại lỗi',
      rong: 'Chưa có loại lỗi nào',
      rongMoTa: 'Tạo từ một exception đang chờ ở trên, hoặc bấm Thêm loại lỗi.',
      cotMa: 'Mã',
      cotTen: 'Tên',
      cotTinhChat: 'Tính chất',
      cotMucDo: 'Mức độ',
      cotCachXuLy: 'Cách xử lý',
      cotException: 'Exception',
      cotBat: 'Bật',
      luongTruoc: 'Lường trước',
      batNgo: 'Bất ngờ',
      thuLai: 'Thử lại {{so}} lần, cách {{giay}} giây',
      khongThuLai: 'Không thử lại',
      hetLanSKIP: 'Hết lần thì bỏ qua và báo',
      hetLanSTOP: 'Hết lần thì dừng lượt chạy',
      xemException: 'Xem exception',
      dangXem: 'Đang xem',
      sua: 'Sửa loại lỗi',
      xoa: 'Xoá loại lỗi',
      xoaBiChan: 'Gỡ hết exception của loại lỗi này trước khi xoá.',
      xoaTieuDe: 'Xoá loại lỗi {{ma}}?',
      xoaThan: 'Loại lỗi {{ma}} ({{ten}}) sẽ bị xoá. Thao tác này không hoàn tác được.',
      daXoa: 'Đã xoá loại lỗi {{ma}}.',
      batNhan: 'Bật loại lỗi {{ma}}',
      daBat: 'Đã bật loại lỗi {{ma}}.',
      daTat: 'Đã tắt loại lỗi {{ma}}.',
    },
    chiTiet: {
      tieuDe: 'Exception của loại lỗi',
      tieuDeCua: 'Exception của loại lỗi {{ma}} · {{ten}}',
      moTa: 'Các exception (và thông điệp, nếu cần) được tính là loại lỗi này.',
      them: 'Thêm exception',
      rong: 'Loại lỗi này chưa có exception nào',
      rongMoTa: 'Thêm exception để Robot nhận ra loại lỗi này.',
      chuaCoCode: 'Chưa có loại lỗi để xem',
      cotException: 'Exception',
      cotThongDiep: 'Thông điệp chứa',
      cotPhanLoai: 'Phân loại',
      cotSoLan: 'Số lần gặp',
      cotLanCuoi: 'Lần cuối gặp',
      cotBat: 'Bật',
      moiThongDiep: 'Mọi thông điệp',
      chuaPhanLoai: 'Chưa phân loại',
      sua: 'Sửa exception',
      go: 'Gỡ exception',
      goTieuDe: 'Gỡ {{exception}} khỏi loại lỗi?',
      goThan:
        '{{exception}} sẽ không còn thuộc loại lỗi này. Lần sau Robot báo lại, exception quay về danh sách chờ. Thao tác này không hoàn tác được.',
      daGo: 'Đã gỡ exception {{exception}}.',
      batNhan: 'Bật {{exception}}',
      daBat: 'Đã bật exception {{exception}}.',
      daTat: 'Đã tắt exception {{exception}}.',
    },
    form: {
      taoTieuDe: 'Tạo loại lỗi',
      suaTieuDe: 'Sửa loại lỗi {{ma}}',
      tuCho: 'Tạo từ exception đang chờ',
      ten: 'Tên loại lỗi',
      tenGoiY: 'Tên người vận hành đọc được, ví dụ Mất kết nối mạng.',
      tenMau: 'Mất kết nối mạng',
      tinhChat: 'Tính chất',
      tinhChatGoiY: 'Lường trước là lỗi bạn biết có thể xảy ra.',
      luongTruoc: 'Lường trước được',
      batNgo: 'Bất ngờ',
      mucDo: 'Mức độ',
      moTa: 'Mô tả',
      moTaGoiY: 'Nguyên nhân và cách xử lý, viết bằng lời thường.',
      cachXuLy: 'Cách xử lý',
      cachXuLyGoiY: 'Robot làm theo các giá trị này mỗi khi gặp loại lỗi này.',
      soLan: 'Số lần thử lại',
      soLanGoiY: '0 là không thử lại. Tối đa {{max}}.',
      gianCach: 'Giây giữa các lần',
      gianCachGoiY: 'Tối đa {{max}} giây.',
      giay: 'giây',
      khiHet: 'Khi hết lần',
      khiHetGoiY: 'Việc làm khi thử lại hết lần mà vẫn lỗi.',
      SKIP: 'Bỏ qua và báo',
      STOP: 'Dừng lượt chạy',
      bat: 'Bật',
      batGoiY: 'Tắt thì exception của loại lỗi này được coi như chưa đặt cách xử lý.',
      loiTen: 'Nhập tên loại lỗi.',
      loiSoLan: 'Số lần thử lại là số nguyên từ 0 đến 10.',
      loiGianCach: 'Số giây là số nguyên từ 0 đến 3600.',
      tao: 'Tạo loại lỗi',
      luu: 'Lưu loại lỗi',
      daTao: 'Đã tạo loại lỗi {{ma}}.',
      daLuu: 'Đã lưu loại lỗi {{ma}}.',
    },
    formCt: {
      themTieuDe: 'Thêm exception cho loại lỗi {{ma}}',
      suaTieuDe: 'Sửa exception',
      exception: 'Exception',
      exceptionGoiY: 'Tên đầy đủ, ví dụ System.Net.WebException.',
      exceptionMau: 'System.NullReferenceException',
      thongDiep: 'Thông điệp chứa',
      thongDiepGoiY:
        'Để trống nếu loại lỗi này áp dụng cho mọi thông điệp của exception. Không phân biệt hoa thường.',
      phanLoai: 'Phân loại',
      phanLoaiGoiY: 'Chọn phân loại đã dùng hoặc gõ tên mới.',
      phanLoaiChon: 'Chọn hoặc gõ phân loại',
      phanLoaiRong: 'Chưa có phân loại nào, gõ để tạo',
      phanLoaiThem: 'Thêm phân loại "{{ten}}"',
      bat: 'Bật',
      batGoiY: 'Tắt thì dòng này không dùng để nhận ra loại lỗi.',
      loiBatBuoc: 'Nhập tên exception.',
      loiSaiDang: 'Tên exception chỉ gồm chữ, số, dấu chấm và gạch dưới, ví dụ System.NullReferenceException.',
      them: 'Thêm exception',
      luu: 'Lưu exception',
      daThem: 'Đã thêm exception {{exception}}.',
      daLuu: 'Đã lưu exception {{exception}}.',
    },
    gan: {
      tieuDe: 'Gán exception vào loại lỗi',
      code: 'Loại lỗi',
      codeGoiY: 'Exception sẽ thuộc loại lỗi này và áp dụng cho mọi thông điệp.',
      codeChon: 'Chọn loại lỗi',
      loiChon: 'Chọn một loại lỗi.',
      gan: 'Gán vào loại lỗi',
      daGan: 'Đã gán vào loại lỗi {{ma}}.',
    },
  },
} as const;
